import cloneDeep from 'lodash/cloneDeep'
import { getFilterItemName, getFilterValue, setFilter } from '@/utilities/org'

const handleAgeRangeSelected = (context, payload) => {
  handleMultipleValueFilterSelected(context, payload)
}

const handleDistanceSelected = (context, payload) => {
  const { name } = payload.item
  const { active, value } = payload.value
  const filterPayload = {}
  if (active) filterPayload[name] = value
  setFilter(context, filterPayload)
  fetch(context)
}

const handleGenderSelected = (context, payload) => {
  handleMultipleValueFilterSelected(context, payload)
}

const handleConditionSelected = async (context, payload) => {
  await fetch(context)
  const is = { category: false, tag: false }
  Object.keys(is).forEach(k => (is[k] = Object.keys(payload.value).includes(k)))
  if (is.tag) refocusTag(context, payload)
  else if (is.category) refocusCategory(context)
}

export const handleFilterSelected = (context, payload) => {
  resetInfiniteLoadParams(context)
  const { item, value } = payload
  if (item.name === 'condition') handleConditionSelected(context, payload)
  else if (item.name === 'studyStatus') handleStudyStatusSelected(context, payload)
  else if (item.name === 'ageRange') handleAgeRangeSelected(context, payload)
  else if (item.name === 'gender') handleGenderSelected(context, payload)
  else if (item.name === 'distance') handleDistanceSelected(context, payload)
  else console.error('selected filter not handled', { item, value })
}

export const handleMultipleValueFilterSelected = (context, payload) => {
  const { options, name } = payload.item
  const { active, value } = payload.value
  const filterItemName = getFilterItemName(options, value)
  const filterValue = filterItemName || getFilterValue(name, value)
  const arr = cloneDeep(context.$store.getters['search/filter'])?.[name]
  if (active) arr.push(filterValue)
  const filterPayload = {}
  filterPayload[name] = active ? arr : arr.filter(v => v !== filterValue)
  setFilter(context, filterPayload)
  fetch(context)
}

export const fetch = async (context) => {
  var queryParams = context.$store.getters['search/params'];
  console.log(queryParams)
  await context.$store.dispatch('search/fetchResults', { data: queryParams })
  if (context.location)
    await context.$store.dispatch('search/fetchDistanceCounts', { data: queryParams })
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'PageView',
    'pagePath' : encodeURIComponent(encodeURIComponent(JSON.stringify(queryParams)))
  })
}


const handleStudyStatusSelected = (context, payload) => {
  handleMultipleValueFilterSelected(context, payload)
}

const refocusCategory = async context => {
  context.$nextTick(() => {
    document.getElementsByClassName('isFirstCategory')[0]?.focus()
  })
}

const refocusTag = async context => {
  context.$nextTick(() => {
    if (context.$store.getters['search/selectedTag'])
      document.getElementsByClassName('isFirstTag')[0]?.focus()
    else document.getElementsByClassName('isFirstCategory')[0]?.focus()
  })
}




const resetInfiniteLoadParams = context => {
  context.$store.commit('search/setOffset', 0)
}
